import type { addGroupSchema } from "@views/App/Groups/components/AddGroup/schemas";
import type { z } from "zod";

export const fixGroupLinks = (links: z.infer<typeof addGroupSchema>["links"]) => {
	const reg = new RegExp(/https{0,1}\:\/\//);
	return links.map((link) => ({ ...link, link: reg.test(link.link) ? link.link : `https://${link.link}` }));
};
